export const organizationActions = {
  populateOrganizations: "POPULATE_ORGANIZATIONS"
};
